import { Boundaries } from "@planzone/core";
import { Gantt } from "@planzone/dto";
import { events } from "@planzone/events";
import { propagateEvent } from "./propagateEvent";

function handleEditConstraint(
  gantt: Gantt,
  data: Boundaries["editConstraint"]["success"],
): Gantt {
  const index = gantt.constraints.findIndex(
    ({ uuid }) => uuid === data.constraint.uuid,
  );

  return {
    ...gantt,
    projects: propagateEvent(gantt, {
      type: events.editConstraintSucceeded,
      data,
    }).projects,
    constraints:
      index !== -1
        ? [
            ...gantt.constraints.slice(0, index),
            data.constraint,
            ...gantt.constraints.slice(index + 1),
          ]
        : [...gantt.constraints, data.constraint],
  };
}

export { handleEditConstraint };
